import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationHelper } from '../helpers/authenticationHelper';
import { CurrentUserStateService } from '../appServices/current-user-state.service';

@Injectable()
export class SuperAdminGuard implements CanActivate {
    constructor(
        private authService: AuthenticationHelper,
        private route: Router,
        private currentUserStateService: CurrentUserStateService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        router: RouterStateSnapshot
    ): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {
        if (this.authService.isLoggedIn() && this.currentUserStateService.isSuperAdmin()) {
            return true;
        }
        if (this.authService.isLoggedIn()) {
            if (route.params && route.params['project_id']) {
                this.route.navigate(['/projects', route.params['project_id']]);
            } else {
                this.route.navigate(['/projects']);
            }
            return false;
        }
        this.route.navigate(['']);
        return false;
    }
}
